import clsx from 'clsx';
import { IconButton } from '../button/IconButton/IconButton';
import { Icon } from '../icon/Icon';
import { ListConductorSort, SortDirection } from '../list-conductor/sort';
import { SORT_SEQUENCE } from '../list-conductor/constants';
import { SORT_LABELS } from './constant';

interface SortButtonProps {
  sortKey: string;
  sortState: ListConductorSort;
  onSort: (sortKey: string, order: SortDirection | undefined) => void;
  className?: string;
  unSortedStateClassname?: string;
  [key: string]: unknown;
}
export function SortButton({
  sortKey,
  sortState,
  onSort,
  unSortedStateClassname = '',
  className,
  ...rest
}: SortButtonProps) {
  const getSortStateIcon = () => {
    if (sortState[sortKey] === SortDirection.ASC) {
      return 'add-arrow-top';
    }
    if (sortState[sortKey] === SortDirection.DESC) {
      return 'add-arrow-bottom';
    }
    return 'navigation-indicator';
  };

  const onClickHandler = () => {
    if (typeof onSort !== 'function') {
      return;
    }

    if (!sortState[sortKey]) {
      onSort(sortKey, SORT_SEQUENCE[SortDirection.RESET].next);
    } else {
      onSort(sortKey, SORT_SEQUENCE[sortState[sortKey]].next);
    }
  };

  return (
    <IconButton
      className={clsx(className, {
        [unSortedStateClassname]: !sortState[sortKey] || sortState[sortKey] === SortDirection.RESET
      })}
      {...rest}
      onClick={() => onClickHandler()}
      dataId={sortKey}
      label={SORT_LABELS[sortState[sortKey]] || SORT_LABELS[SortDirection.RESET]}
    >
      <Icon dataId={`${sortKey}-sort-direction`} name={getSortStateIcon()} />
    </IconButton>
  );
}
